import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';
import { OrderListCustomFilter, OrderListFilter, OrderListItemPage } from '../models/treatment';

/** Provides the endpoints served to lab technicians only. */
@Injectable({ providedIn: 'root' })
export class TechnicianApiClient {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiBaseUrl: string = environment.apiBaseUrl.replace(/\/$/, '');
  private readonly baseUrl: string = `${this.apiBaseUrl}/technician`;

  /** Returns twenty orders routed to the calling technician's lab, from a one-based page. */
  public getOrders(page: number, filter: string, customFilter: OrderListCustomFilter): Observable<OrderListItemPage> {
    const request: OrderListFilter = {
      page,
      rowsOnPage: 20,
      orderBy: 'ModifiedDate desc',
      filter: filter.trim(),
      customFilter,
    };
    return this.http.post<OrderListItemPage>(`${this.baseUrl}/orders/page`, request);
  }
}
